import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllSalaryEmployees, GetEmployeeSalarySlips, CreateSalarySlip, DeleteSalarySlip, UpdateSalaryRelease, GenerateAndReleaseSalaryForAll, GetByPayrollID, GetPreviousMonthPayroll, BulkUploadSalarySlips, DownloadSalaryFormat, SendPayslipLinkEmail, GetSalaryPaidReport } from "helpers/api_method";

export const getAllSalaryUsers = createAsyncThunk("salarypayroll/getAllUsers", async () => {
    try {
        const response = await GetAllSalaryEmployees();
        return response.data;
    } catch (error) {
        return error;
    }
});
export const getAllSalarySlipsByEmployeeID = createAsyncThunk("salarypayroll/getAllSalarySlipsByEmployeeID", async (event: any) => {
    try {
        const response = await GetEmployeeSalarySlips(event);
        return response.data;
    } catch (error) {
        return error;
    }
});
export const getPaySlipByID = createAsyncThunk("salarypayroll/getPaySlipByID", async (event: any) => {
    try {
        const response = await GetByPayrollID(event);
        return response.data;
    } catch (error) {
        return error;
    }
});
export const addNewDEmployeePayroll = createAsyncThunk("salarypayroll/addNewDEmployee", async (event: any) => {
    try {
        const response = await CreateSalarySlip(event);
        toast.success("Salary Details created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Salary Details creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const generateAndReleaseForAll = createAsyncThunk("salarypayroll/generateAndReleaseForAll", async (event: any) => {
    try {
        const response = await GenerateAndReleaseSalaryForAll(event);
        toast.success("Salary Slip created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Salary Slip creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateSalaryReleaseStatus = createAsyncThunk("salarypayroll/updateSalaryReleaseStatus", async (event: any) => {
    try {
        const response = await UpdateSalaryRelease(event, event);
        toast.success("Salary Released Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Salary release Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteExistingEmployeeSalary = createAsyncThunk("salarypayroll/deleteExistingEmployee", async (event: any) => {
    try {
        const response = await DeleteSalarySlip(event.id);
        toast.success("Salary Slip deleted Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Salary Slip deletion Failed", { autoClose: 2000 });
        return error;
    }
});

export const getPreviousMonthPayroll = createAsyncThunk("salarypayroll/getPreviousMonthPayroll", async (arg: { employeeId: string; pay_month?: number; pay_year?: number }) => {
    try {
        const { employeeId, pay_month, pay_year } = typeof arg === 'object' && arg !== null && 'employeeId' in arg
            ? arg
            : { employeeId: arg as unknown as string, pay_month: undefined, pay_year: undefined };
        const response = await GetPreviousMonthPayroll(employeeId, pay_month, pay_year);
        return response.data;
    } catch (error) {
        return error;
    }
});

export const bulkUploadSalarySlips = createAsyncThunk("salarypayroll/bulkUploadSalarySlips", async (data: any) => {
    try {
        const response = await BulkUploadSalarySlips(data.employee_id, data.formData);
        toast.success("Salary slips uploaded successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Salary slips upload failed", { autoClose: 2000 });
        return error;
    }
});

export const downloadSalaryFormat = createAsyncThunk("salarypayroll/downloadSalaryFormat", async () => {
    try {
        const response = await DownloadSalaryFormat();
        return response.data;
    } catch (error) {
        toast.error("Failed to download format", { autoClose: 2000 });
        return error;
    }
});

export const sendPayslipLinkEmail = createAsyncThunk("salarypayroll/sendPayslipLinkEmail", async (payrollId: string) => {
    try {
        const response = await SendPayslipLinkEmail(payrollId);
        toast.success("Payslip email sent successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Failed to send payslip email", { autoClose: 2000 });
        return error;
    }
});

export const getSalaryPaidReport = createAsyncThunk("salarypayroll/getSalaryPaidReport", async (params: { pay_month?: string; pay_year?: string }) => {
    try {
        const response = await GetSalaryPaidReport(params.pay_month, params.pay_year);
        return response.data;
    } catch (error) {
        return error;
    }
});
